import Compset from '@/components/Compset';

export default function CompsetSetupPage() {
  return (
    <Compset 
      mode='create'
    />
  )
}
